import React from 'react'

import InventoryMonitorsShow from '@shared/inventory_monitors/InventoryMonitorsShow'
import { inventoryMonitorService } from '@services/admin/inventoryMonitorService'
import { useLoaderData } from 'react-router-dom'

export default function AdminInventoryMonitorsShow() {
  const inventoryMonitor = useLoaderData()

  return (
    <InventoryMonitorsShow
      inventoryMonitor={inventoryMonitor}
      inventoryMonitorService={inventoryMonitorService}
      role="admin"
    />
  )
}
